/**
 * The Garden Retreat - Theme JavaScript
 */

(function() {
  'use strict';

  // ===== Mobile Menu Toggle =====
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const headerNav = document.querySelector('.header__nav');
  
  if (mobileToggle && headerNav) {
    mobileToggle.addEventListener('click', function() {
      const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', !isExpanded);
      headerNav.classList.toggle('active');
      
      // Animate hamburger icon
      mobileToggle.classList.toggle('active');
    });

    // Close menu when clicking a nav link
    headerNav.querySelectorAll('.header__nav-link, .header__cta').forEach(function(link) {
      link.addEventListener('click', function() {
        headerNav.classList.remove('active');
        mobileToggle.classList.remove('active');
        mobileToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ===== Smooth Scroll for Anchor Links =====
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ===== Header Hide on Scroll =====
  let lastScrollY = window.scrollY;
  const header = document.querySelector('.header');
  
  if (header) {
    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > 100) {
        if (currentScrollY > lastScrollY) {
          // Scrolling down
          header.classList.add('header--hidden');
        } else {
          // Scrolling up
          header.classList.remove('header--hidden');
        }
      } else {
        header.classList.remove('header--hidden');
      }
      
      lastScrollY = currentScrollY;
    }, { passive: true });
  }

  // ===== Intersection Observer for Animations =====
  const animatedElements = document.querySelectorAll('[data-animate]');
  
  if (animatedElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    animatedElements.forEach(el => observer.observe(el));
  }

  // Registration form validation is handled directly in the registration section's
  // inline script (registration.liquid) which has comprehensive multi-step, multi-guest
  // validation and cart submission logic. No duplicate handler needed here.

  // ===== Cart Janitor =====
  // The registration flow is the only legitimate way items enter the cart, and
  // every legitimate cart contains a paid room. A non-empty cart totaling $0
  // holds only free workshop seats, which means it was assembled outside the
  // flow (e.g. a /cart/add?id=... link) — clear it so it can never reach
  // checkout as a free order.
  fetch('/cart.js')
    .then(function(res) { return res.ok ? res.json() : null; })
    .then(function(cart) {
      if (cart && cart.item_count > 0 && cart.total_price === 0) {
        fetch('/cart/clear.js', { method: 'POST' });
      }
    })
    .catch(function() { /* network hiccup — nothing to clean */ });

  // ===== Lazy Loading Images =====
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading supported
    document.querySelectorAll('img[data-src]').forEach(img => {
      img.src = img.dataset.src;
    });
  } else {
    // Fallback for older browsers
    const lazyImages = document.querySelectorAll('img[data-src]');
    
    if (lazyImages.length > 0 && 'IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            imageObserver.unobserve(img);
          }
        });
      });
      
      lazyImages.forEach(img => imageObserver.observe(img));
    }
  }

})();
